<a
  mat-list-item
  [lines]="2"
  uiLink
  [link]="'/configurable-bundles/' + suggestion().bundle?.templateId"
  (click)="clicked.emit()"
>
  <img
    [alt]="suggestion().name"
    [src]="standardImage()?.small ?? './assets/img/package.svg'"
    height="56"
    width="56"
    matListItemIcon
  >

  <span matListItemTitle>{{ suggestion().name }}</span>
  <ng-container matListItemLine>
    <ui-product-bundle-label></ui-product-bundle-label>
  </ng-container>

  <div matListItemMeta class="bundle-action">
    <ui-button-link [link]="link()">
      @if (isMobile()) {
        <span>anzeigen</span>
      } @else {
        <ui-icon faName="arrow-right" faStyle="solid"></ui-icon>
        &nbsp;
          Paket zusammenstellen
      }
    </ui-button-link>
  </div>
</a>
